
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.444","height":"14.4"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Component 1356 – 1","fill":"none","stroke":"#444","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.4"}},[_c('path',{attrs:{"data-name":"Path 3401","d":"M11.534 13.207l4.136-4.136a.185.185 0 0 0 0-.3l-1.576-1.57a.185.185 0 0 0-.3 0l-4.132 4.135-.1.1-.392 2.165 2.167-.394z"}}),_c('path',{attrs:{"data-name":"Line 1641","d":"M14.488 10.253L12.617 8.48"}}),_c('path',{attrs:{"data-name":"Path 3402","d":"M6.215 13.7H1.882A1.138 1.138 0 0 1 .7 12.518V1.882A1.138 1.138 0 0 1 1.882.7h8.667a1.138 1.138 0 0 1 1.181 1.182v3.742"}}),_c('g',{attrs:{"data-name":"Group 5663"}},[_c('path',{attrs:{"data-name":"Line 1642","d":"M3.458 4.048h5.515"}}),_c('path',{attrs:{"data-name":"Line 1643","d":"M3.458 6.313h5.515"}}),_c('path',{attrs:{"data-name":"Line 1644","d":"M3.458 8.677h1.97"}})])])])
          )
        }
      }
    